import { Filter, ArrowRight } from "lucide-react";
import { COLORS } from "../styles/tokens";
import type { TabId } from "./Header";

interface StickyMobileBarProps {
  activeFilterCount: number;
  setFiltersOpen: (open: boolean) => void;
  setTab: (tab: TabId) => void;
}

/**
 * StickyMobileBar — bottom sticky action bar shown on mobile only,
 * while the user is on the Explorer tab and no drawer is open.
 *
 * Provides one-tap access to the filter sheet and the primary "Get a seat" CTA.
 */
export function StickyMobileBar({ activeFilterCount, setFiltersOpen, setTab }: StickyMobileBarProps) {
  return (
    <div
      style={{
        position: "fixed",
        bottom: 16,
        left: 16,
        right: 16,
        zIndex: 40,
        display: "flex",
        gap: 8,
      }}
    >
      <button
        onClick={() => setFiltersOpen(true)}
        style={{
          flex: 1,
          background: "rgba(15, 26, 44, 0.95)",
          backdropFilter: "blur(20px)",
          color: COLORS.ink,
          border: `1px solid ${activeFilterCount > 0 ? `${COLORS.cyan}66` : COLORS.borderHi}`,
          padding: "14px",
          borderRadius: 999,
          fontSize: 13,
          fontWeight: activeFilterCount > 0 ? 600 : 500,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 8,
          boxShadow:
            activeFilterCount > 0
              ? `0 8px 32px rgba(0,0,0,0.5), 0 0 0 1px ${COLORS.cyan}22`
              : "0 8px 32px rgba(0,0,0,0.5)",
        }}
      >
        <Filter size={14} /> {activeFilterCount > 0 ? `Filters · ${activeFilterCount}` : "Filter"}
      </button>
      <button
        onClick={() => setTab("onboard")}
        style={{
          flex: 1,
          background: COLORS.blue,
          color: "#ffffff",
          border: `1px solid rgba(59, 130, 246, 0.6)`,
          padding: "14px",
          borderRadius: 999,
          fontSize: 13,
          fontWeight: 700,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 8,
          boxShadow: "0 0 20px rgba(59, 130, 246, 0.3)",
        }}
      >
        Get a seat <ArrowRight size={14} />
      </button>
    </div>
  );
}
